<div
    class="loading-overlay"
    *ngIf="loading$ | async">

    <div class="loading-card">

        <div class="spinner-border text-primary"
             role="status">
        </div>

        <h5 class="mt-4 mb-2">
            Cargando información...
        </h5>

        <p class="text-muted mb-0">
            Espere un momento.
        </p>

    </div>

</div>